import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';
import App from './App.tsx';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
